<template>
  <v-card flat>
    <v-select
      :items="chartViewModes"
      @change="HandleChartViewMode"
      label="View Mode"
    ></v-select>
    <!-- <v-checkbox
      v-if="this.viewMode == 'Line'"
      v-model="dateMode"
      :label="'Date Mode'"
    ></v-checkbox> -->

    <v-btn-toggle v-model="toggle_exclusive">
      <v-btn
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 100, 'years'))
          )
        "
      >
        All Time
      </v-btn>
      <v-btn
        v-if="this.validDateRanges.five_years"
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 5, 'years'))
          )
        "
      >
        past 5 years
      </v-btn>
      <v-btn
        v-if="this.validDateRanges.one_year"
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 1, 'years'))
          )
        "
      >
        past year
      </v-btn>
      <v-btn
        v-if="this.validDateRanges.three_months"
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 3, 'months'))
          )
        "
      >
        past 3 month
      </v-btn>

      <v-btn
        v-if="this.validDateRanges.one_month"
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 1, 'months'))
          )
        "
      >
        past month
      </v-btn>
      <v-btn
        v-if="this.validDateRanges.one_week"
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 1, 'weeks'))
          )
        "
      >
        past week
      </v-btn>

      <v-btn
        v-if="this.validDateRanges.past_day"
        x-small
        @click="
          SetDateRange(
            formatIntoIso8601(subtractFromDate(Date.now(), 1, 'days'))
          )
        "
      >
        24hrs
      </v-btn>
      <v-btn x-small @click="showCustomRangeMenu = true">Custom Range</v-btn>
    </v-btn-toggle>
    <v-row class="justify-center align-center" v-if="showCustomRangeMenu">
      <h3 class="mr-1">Custom range:</h3>
      <v-col cols="4">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="datePickerStartDate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="datePickerStartDate"
              label="Start Date"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="datePickerStartDate"
            no-title
            scrollable
            @change="save"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu.save(datePickerStartDate)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="4">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :return-value.sync="datePickerEndDate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="datePickerEndDate"
              label="End Date"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="datePickerEndDate"
            no-title
            scrollable
            @change="save1"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu1 = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu1.save(datePickerEndDate)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-btn small @click="setCustomDateRange()">Update Chart</v-btn>
    </v-row>
    <v-card-title v-if="!isEmbedded">
      <span class="text-h6">{{ periodic.name }}</span>
    </v-card-title>
    <v-divider v-if="isEmbedded"></v-divider>
    <span v-if="seeChart">
      <component
        :is="computeViewMode"
        :key="values.length"
        @on-receive="updateChart"
        :timestamps="timestamps"
        :valuesList="values"
        :UomArray="UomArray"
        :viewMode="viewMode"
        :showByDate="dateMode"
        class="mt-2 mb-4 mr-4"
      />
    </span>

    <div v-if="!isEmbedded">
      <v-select
        @click="HandlePeriodicGroupItemName($event)"
        :items="ComputedPeriodicGroupItems"
        item-value="data"
        item-text="name"
        @change="HandlePeriodicGroupItem"
        label="Compare Against"
      ></v-select>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import LineChart from "./LineChart.vue";
import BarChart from "./BarChart";
import moment from "moment";
import RadarChart from "./RadarChart.vue";
import DoughnutChart from "./DoughnutChart.vue";
import { FetchPeriodicDateRange, FetchValidDates } from "../../api/index";
import { mdiPencil, mdiCheck, mdiClose, mdiCalendarBlank } from "@mdi/js";
export default {
  name: "Charts",
  components: {
    LineChart,
    BarChart
  },
  props: {
    node: Object,
    isEmbedded: Boolean
  },
  data: () => ({
    chartTypes: ["Doughnut", "Line-Bar", "Radar"],
    chartViewModes: ["Line", "Bar"],
    viewMode: "Line",
    dateMode: false,
    seeChart: false,
    chartSelected: "Line-Bar",
    selectedData: null,
    addToChart: false,
    editChart: false,
    xLabel: new Date().toISOString().substr(0, 10),
    menu: false,
    menu1: false,
    showCustomRangeMenu: false,
    addLabel: "",
    svgPencil: mdiPencil,
    svgCheck: mdiCheck,
    svgClose: mdiClose,
    svgCalendarBlank: mdiCalendarBlank,
    values: [],
    timestamps: [],
    missingLabel: false,
    dateRange: ["", ""],
    unformattedTimestamps: [],
    unformattedAddedTimestamps: [],
    periodicLen: 0,
    rangeSelectDates: [],
    rangeStart: "",
    rangeEnd: "",
    UomArray: [],
    ///multi graph///
    comparedAgainstItem: null,
    currentDateRangeStart: null,
    currentDateRangeEnd: null,
    PeriodicGroupItems: [],
    toggle_exclusive: 0,
    datePickerStartDate: "",
    datePickerEndDate: "",
    validDateRanges: {},
    comparedPeriodicName: ""
  }),
  created() {
    this.prepChartData(this.getValues());
    this.getPeriodicGroupItems();
    this.getValidDates();
  },

  computed: {
    ...mapState({
      RecordId: state => state.records.currentlySelectedTab.recordId,
      RecordItemId: state => state.records.currentlySelectedTab.recordItemId,
      RecordIndex: state => state.records.currentlySelectedRecordIndex
    }),
    ...mapGetters({
      updatedChartValues: "getUpdatedChartValues",
      valuesAddedCheck: "getValuesAddedToChartCheck",
      getChart: "getChart",
      periodic: "getRecordItem"
    }),
    ComputedPeriodicGroupItems: function() {
      let arr = [];
      for (let item of this.PeriodicGroupItems) {
        if (item._id != this.RecordItemId) {
          arr.push(item);
        }
      }
      return arr;
    },
    computeViewMode: function() {
      switch (this.viewMode) {
        case "Line":
          return LineChart;
        case "Bar":
          return BarChart;

        default:
          return LineChart;
      }
    }
  },
  methods: {
    ...mapActions(["FindPeriodicGroupItems", "getRecordItemOnDemand"]),
    prepChartData(valuePackage, resetchart = true) {
      this.values = [];
      this.UomArray = [];
      this.timestamps = [];

      if (resetchart) {
        if (this.periodic.meta.periodic) {
          console.log("this.periodic", this.periodic);

          this.valueNames = this.periodic.meta.value_name
            ? this.periodic.meta.value_name
            : false;
          if (!this.valueNames) {
            if (this.periodic.data?.name)
              this.valueNames = [this.periodic.data.name];
            if (this.periodic.name) this.valueNames = [this.periodic.name];
          }
        } else if (this.node.meta.value_name) {
          this.valueNames = this.node.meta.value_name
            ? this.node.meta.value_name
            : [this.node.data.name];
        } else if (this.node.data.name) {
          this.valueNames = this.node.data.name;
        }
      }
      if (!this.valueNames || !this.valueNames[0]) {
        if (this.node?.data.name) {
          this.valueNames = [this.node?.data.name];
        } else {
          this.valueNames = [this.periodic.name];
        }
      }

      // Get Value array
      let linesArray = valuePackage;
      // Get Length of val array
      let valLength = linesArray[0].val.length;
      let parsedList;
      // Separate vals into different arrays
      // push arrays onto this.values
      // this.values is what is passed to our charts
      for (var i = 0; i < valLength; ++i) {
        parsedList = this.parseValueArray(linesArray, i);
        this.values.push(parsedList);
      }

      //package the names with the values,matched by index
      this.values = [{ valueList: this.values, valueNames: this.valueNames }];

      // Grab timestamps to pass to our
      // charts to fill their x-axis labels
      this.getTimestamps(linesArray);
      // Reveal chart
      this.seeChart = true;

      //check if there is a already compared item
      if (this.comparedAgainstItem) {
        // this.comparedAgainstItemAdded = true;
        // this.addPeriodicGroupItem(this.comparedAgainstItem);
        FetchPeriodicDateRange(this.comparedAgainstItem._id, [
          this.currentDateRangeStart,
          this.currentDateRangeEnd
        ]).then(res => {
          this.addPeriodicGroupItem(res.data, true);
        });
      }
    },
    // Function grabs timestamps and pushes
    // them on array to pass to our charts
    getTimestamps(vitals) {
      let datesUsed = [];
      // Get Time Stamps
      for (var i = 0; i < vitals.length; ++i) {
        let time;
        let fullDate;

        // Format timestamps
        let date = moment(vitals[i].eventTimestamp).format("ll");
        // To fill v-selects for range selection
        this.rangeSelectDates.push(
          moment(vitals[i].eventTimestamp).format("lll")
        );
        // Check if date formatted as (mm/dd/yy) is in array
        // * If it isn't in datesUsed push new date to datesUsed
        // and set fullDate to (mm/dd/yy | hour:min:ms)
        // * Else if date is in datesUsed set fullDate to just time (hour:min:ms)
        var dateCheck = datesUsed.includes(date);
        if (!dateCheck) {
          datesUsed.push(date);
          time = moment(vitals[i].eventTimestamp).format("LT");
          fullDate = date.concat(" | ", time);
        } else {
          fullDate = moment(vitals[i].eventTimestamp).format("LT");
        }
        // Get unformatted timestamp array
        this.unformattedTimestamps.push(vitals[i].eventTimestamp);
        // Push full date to timestamps
        // Timestamps used for x-axis labels
        this.timestamps.push(fullDate);
      }

      if (this.periodic.meta.uom && this.UomArray.length === 0) {
        this.UomArray.push(this.periodic?.meta.uom);
      } else if (this.node?.meta.uom && this.UomArray.length === 0) {
        this.UomArray.push(this.node.meta.uom);
      } else {
        this.UomArray.push(this.periodic?.name);
      }
    },
    // Function grabs vals, creates object,
    // pushes objects onto arr, and returns arr
    // to be pushed onto this.values
    parseValueArray(ValueArray, valIndex) {
      let arr = [];
      let obj = {};

      for (var i = 0; i < ValueArray.length; ++i) {
        obj = {
          y: ValueArray[i].val[valIndex],
          x: ValueArray[i].timestamp
        };
        arr.push(obj);
      }

      return arr;
    },
    // Function gets values array
    getValues() {
      if (this.node?.value) {
        return this.node.value;
      } else {
        return this.periodic.value;
      }

      //periodic is NON embedded and node is embedded
      // if (this.periodic.value) {
      //   return this.periodic.value;
      // } else {
      //   return this.node.value;
      // }
    },
    // Sets points selected on chart to this.selectedData
    getValidDates() {
      FetchValidDates(this.RecordItemId).then(
        data => (this.validDateRanges = data.data)
      );
    },
    updateChart(data) {
      this.addToChart = false;
      this.selectedData = data;
    },
    //// multi graph///
    getPeriodicGroupItems() {
      let recordItem;
      this.getRecordItemOnDemand({
        recorditemid: this.RecordItemId,
        recordid: this.RecordId
      }).then(res => {
        recordItem = res;
        this.FindPeriodicGroupItems({
          recordItemId: this.RecordItemId,
          recordItem,
          RecordIndex: this.RecordIndex
        }).then(groupitems => {
          this.PeriodicGroupItems = groupitems;
        });
      });
    },
    HandlePeriodicGroupItem(item) {
      this.addPeriodicGroupItem(item);
    },
    addPeriodicGroupItem(item, isDateRange = false) {
      //save periodic group item for reference
      if (!isDateRange) {
        this.comparedAgainstItem = item;
      }

      // add value to values array
      this.parseAndSetAllValues(item);
      // add uom to legend
      this.UomArray.push(this.comparedAgainstItem.meta.uom);
    },
    parseAndSetAllValues(item) {
      let comparedValues = [];
      let comparedValueNames = [];
      let parsedValues;

      if (item.value) {
        let record;
        this.getRecordItemOnDemand({
          recorditemid: item.cat_id,
          recordid: this.RecordId
        }).then(res => {
          record = res;
        });
        for (let i = 0; i < item.value[0].val.length; i++) {
          parsedValues = this.parseValueArray(item.value, i);
          comparedValues.push(parsedValues);

          comparedValueNames.push(
            item.meta.value_name
              ? item.meta.value_name[i]
              : this.comparedPeriodicName
          );
        }
      } else {
        for (let i = 0; i < item[0].val.length; i++) {
          parsedValues = this.parseValueArray(item, i);
          comparedValues.push(parsedValues);

          comparedValueNames.push(
            this.comparedAgainstItem.meta.value_name
              ? this.comparedAgainstItem.meta.value_name[i]
              : this.comparedAgainstItem.name
          );
        }
      }

      this.values.push({
        valueList: comparedValues,
        valueNames: comparedValueNames
      });
    },
    HandleChartViewMode(mode) {
      this.dateMode = false;
      this.viewMode = mode;
    },
    formatIntoIso8601(date) {
      return date.toISOString();
    },
    subtractFromDate(date, numberToSubtract, typeToSubtract) {
      return moment(date).subtract(numberToSubtract, typeToSubtract);
    },
    SetDateRange(start, end = "nodate") {
      if (end === "nodate") {
        let x = new Date();
        end = x.toISOString();
      }

      this.showCustomRangeMenu = false;
      this.currentDateRangeStart = start;
      this.currentDateRangeEnd = end;

      FetchPeriodicDateRange(this.RecordItemId, [start, end]).then(res =>
        this.prepChartData(res.data, false)
      );
    },
    setCustomDateRange() {
      if (this.datePickerStartDate && this.datePickerEndDate) {
        this.SetDateRange(this.datePickerStartDate, this.datePickerEndDate);
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    save1(date) {
      this.$refs.menu1.save(date);
    },
    HandlePeriodicGroupItemName($event) {}
  }
};
</script>
<style></style>
